
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[id]",
      function () {
        return require("private-next-pages/coaches/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[id]"])
      });
    }
  